export default function makeBgImage() {
    const defaultBgOptions = {
        attachment: 'fixed',
        size: 'cover',
        position: 'center',
        repeat: 'no-repeat'
    };

    document.querySelectorAll("img.bg-image").forEach(image => {
        const src = image.getAttribute('src');
        const positionData = image.dataset.bgPosition || defaultBgOptions.position;
        const attachmentData = image.dataset.bgAttachment || defaultBgOptions.attachment;
        const sizeData = image.dataset.bgSize || defaultBgOptions.size;
        const repeatData = image.dataset.bgRepeat || defaultBgOptions.repeat;

        image.parentNode.style.backgroundImage = `url(${src})`;
        image.parentNode.style.backgroundAttachment = attachmentData;
        image.parentNode.style.backgroundSize = sizeData;
        image.parentNode.style.backgroundPosition = positionData;
        image.parentNode.style.backgroundRepeat = repeatData;
        image.remove();
    });
}
